import { render, staticRenderFns } from "./previaExame.vue?vue&type=template&id=6bddfc2c&"
import script from "./previaExame.vue?vue&type=script&lang=js&"
export * from "./previaExame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports